<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {};
</script>

<style lang="scss">
// ====== GLOBAL STYLES ======
.component-wrapper {
  background: #FBF8F1;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flex-1 {
  flex: 1 1 0px;
}

.scrollable {
  overflow-y: scroll;
}

.clickable {
  cursor: pointer;
}

// veutify overriding
.v-main.primary {
  justify-content: center;
}

.v-main__wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.v-btn__content {
  justify-content: flex-start !important;
}

.v-data-table {
  tr {
    height: 70px !important;

    td, th {
      font-size: 1.2rem !important;
    }

    &.v-data-table__mobile-table-row {
      height: auto !important;
      padding-top: 10px !important;
    }
  }
}

.no-message .v-text-field__details,
.v-messages {
  min-height: 0px !important;
  height: 0px !important;
}

// .v-dialog {
//   width: 80vw !important;
//   height: 80vw !important;

//   .v-card.v-sheet {
//     height: 100% !important;
//   }
// }

// css overiding
::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: #FF9800;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  cursor: pointer;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

html,
body {
  height: 100%;
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

#root,
#__next {
  isolation: isolate;
}
</style>
